import _memoize from 'lodash/memoize';
import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { FONT, getFont } from '@tornado-rdk/typography';
import { TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';
import { TRANSPARENT } from '../../../tornado/utils/colors';
import { SHOULD_DISPLAY } from './contentAdvisory.constants';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../../../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const MAX_TEXT_WIDTH = {
  [HD]: 640,
  [FULL_HD]: 960,
};

export const PADDING_LEFT = {
  [HD]: 64,
  [FULL_HD]: 96,
};

export const PADDING_TOP = {
  [HD]: 40,
  [FULL_HD]: 56,
};

export const TITLE_MARGIN_BOTTOM = {
  [HD]: 8,
  [FULL_HD]: 8,
};

export const DESCRIPTION_MARGIN_BOTTOM = {
  [HD]: 16,
  [FULL_HD]: 16,
};

export const ICONS_MARGIN_BOTTOM = {
  [HD]: 16,
  [FULL_HD]: 16,
};

export const ICON_SIZE = {
  WIDTH: {
    [HD]: 32,
    [FULL_HD]: 40,
  },
  HEIGHT: {
    [HD]: 32,
    [FULL_HD]: 40,
  },
};

export const getIconViewBox = _memoize(screenSize => ({
  w: ICON_SIZE.WIDTH[screenSize],
  h: ICON_SIZE.HEIGHT[screenSize],
}));

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const titleFont = getFont(FONT.OTTAWA_2, screenSize);
  const descriptionFont = getFont(FONT.OTTAWA_1, screenSize);
  const wordWrapWidth = MAX_TEXT_WIDTH[screenSize];

  return {
    visible: SHOULD_DISPLAY,
    Treatment: {
      visible: false,
      rect: true,
      w: SCREEN_WIDTH[screenSize],
      h: SCREEN_HEIGHT[screenSize],
      colorUl: makeThemeColor(TERTIARY, 0.8)[colorMode],
      colorUr: TRANSPARENT,
      colorBr: TRANSPARENT,
      colorBl: TRANSPARENT,
    },
    Content: {
      flex: {
        direction: 'column',
        justifyContent: 'flex-start',
        paddingLeft: PADDING_LEFT[screenSize],
        paddingTop: PADDING_TOP[screenSize],
      },
      zIndex: 2,
      Icons: {
        flex: {
          direction: 'row',
          justifyContent: 'flex-start',
        },
        flexItem: {
          marginBottom: ICONS_MARGIN_BOTTOM[screenSize],
        },
      },
      Title: {
        flexItem: {
          marginBottom: TITLE_MARGIN_BOTTOM[screenSize],
        },
        text: {
          ...titleFont,
          wordWrapWidth,
          maxLines: 1,
          maxLinesSuffix: '...',
          verticalAlign: 'middle',
        },
      },
      Description: {
        flexItem: {
          marginBottom: DESCRIPTION_MARGIN_BOTTOM[screenSize],
        },
        text: {
          ...descriptionFont,
          wordWrapWidth,
          maxLines: 2,
          maxLinesSuffix: '...',
          verticalAlign: 'middle',
        },
      },
    },
  };
};
